export var MuiAppBar = {
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                backgroundColor: theme.palette.common.white,
                borderBottomColor: theme.palette.grey[200],
                borderBottomStyle: "solid",
                borderBottomWidth: 1,
                boxShadow: "none",
                color: theme.palette.grey[900],
                lineHeight: 1,
            });
        },
    },
};
